import { createClient } from "@supabase/supabase-js";

// Auth uses native Supabase Auth (signInWithPassword). RLS policies on
// clinical_docs / clinical_audit_log should gate on auth.uid().
const url = process.env.REACT_APP_SUPABASE_URL;
const key = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!url || !key) console.error("Missing Supabase env vars");

// [clinical-diag] Temporary diagnostics — see PR. Confirms which Supabase URL
// the deployed bundle was built against and whether the anon key was inlined.
// Note: react-scripts only inlines REACT_APP_*-prefixed env vars at build time;
// VITE_*-named vars would NOT be picked up here.
console.log("[clinical-diag] supabaseClient: url =", url, "| anon key inlined =", !!key);

export const supabase = createClient(url, key);
